import { FC } from 'react';
import { SvgIcon } from '@/components';
import './multi-lan-tag.less';
import classNames from 'classnames';
interface MultiLanTagProps {
  value?: string;
  close?: boolean;
  error?: boolean;
  disabled?: boolean;
  className?: string;
  onClose?: () => void;
}
const MultiLanTag: FC<MultiLanTagProps> = ({
  value = '',
  className = '',
  close = true,
  error = false,
  disabled = false,
  onClose = () => {},
}) => {
  return (
    <div
      className={classNames('multi-lan-tag flex-between', className, {
        canClose: close,
        error,
      })}
    >
      <span className="span-content">{value}</span>
      {close && (
        <div
          className="tag-close"
          onClick={() => {
            if (!disabled) {
              onClose();
            }
          }}
        >
          <SvgIcon
            className="close"
            name={error ? 'close-red' : 'close'}
            width="16"
            height="16"
          />
          <SvgIcon
            className="close-hover"
            name={'close-hover'}
            width="16"
            height="16"
          />
        </div>
      )}
    </div>
  );
};
export default MultiLanTag;
